import React from "react";
import { createPortal } from "react-dom";

interface ModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  /** Ícone opcional exibido em um badge circular ao lado do título — usar para
   * chamar atenção em ações críticas/irreversíveis (ex.: cancelamento). */
  icon?: React.ReactNode;
  /** Cor do badge do ícone. "danger" usa o tom vermelho/coral de alerta do design system. */
  tone?: "default" | "danger";
  children: React.ReactNode;
  actions?: React.ReactNode;
  wide?: boolean;
}

const Modal: React.FC<ModalProps> = ({ open, onClose, title, icon, tone = "default", children, actions, wide }) => {
  if (!open) return null;

  return createPortal(
    <div className="ds">
      <div
        className="ds-backdrop"
        style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}
        onClick={onClose}
      >
        <div className={`ds-modal ${wide ? "wide" : ""}`} onClick={(e) => e.stopPropagation()}>
          <div className="ds-modal-head">
            {icon && <span className={`ds-modal-icon-badge ${tone === "danger" ? "danger" : ""}`}>{icon}</span>}
            <h3>{title}</h3>
          </div>
          <div>{children}</div>
          {actions && <div className="ds-modal-actions" style={{ marginTop: 20 }}>{actions}</div>}
        </div>
      </div>
    </div>,
    document.body
  );
};

export default Modal;
